export const navBarCollapsedSetting = 'IsNavBarCollapsed';
